import { browserPopupRedirectResolver, getAuth, GoogleAuthProvider, signInWithPopup } from 'firebase/auth'
import { collection, doc, getDocs, query, serverTimestamp, setDoc, where } from 'firebase/firestore'
import toast from 'react-hot-toast'
import { app, firestore } from './firebaseConfig'

export const signInWithGoogle = async () => {
  const auth = getAuth()
  try {
    const cred = await signInWithPopup(auth, new GoogleAuthProvider(), browserPopupRedirectResolver)
    const user = cred.user

    // Experimental Admin Login
    const token = await user.getIdToken()

    // Set the JWT Cookie
    await fetch('/api/setCookie', {
      method: 'POST',
      body: JSON.stringify({ token }),
      headers: {
        'Content-Type': 'application/json',
      },
    })

    const response = await fetch('/api/getUserRole', {
      method: 'POST',
      body: JSON.stringify({ token }),
      headers: {
        'Content-Type': 'application/json',
      },
    })
    const { admin, employee } = await response.json()

    const q = query(collection(firestore, 'users'), where('uid', '==', user.uid))
    const docs = await getDocs(q)
    if (docs.empty) {
      await setDoc(doc(firestore, 'users', user.uid), {
        uid: user.uid,
        name: user.displayName,
        authProvider: 'google',
        email: user.email,
        dateCreated: serverTimestamp(),
        amountActiveAppointments: 0,
        amountInactiveAppointments: 0,
      })
    }

    return { admin, employee }
  } catch (err: any) {
    toast.error('Fehler beim Anmelden.')
    return { admin: null, employee: null }
  }
}

// export const createUser = async (email: string, password: string) => {
//   try {
//     const userCred = await createUserWithEmailAndPassword(auth, email, password)
//     await sendEmailVerification(userCred.user, { url: 'http://localhost:3000/dashboard' })
//     return { user: userCred.user }
//   } catch (error: any) {
//     return { error: error.message }
//   }
// }

// export const logInUserWithEmailAndPassword = async (email: string, password: string) => {
//   try {
//     const userCred = await signInWithEmailAndPassword(auth, email, password)
//     return { user: userCred.user }
//   } catch (error: any) {
//     return { error: error.message }
//   }
// }

// export const signUserOut = async () => {
//   await signOut(auth)
// }

// export const resetPassword = async (email: string) => {
//   try {
//     await sendPasswordResetEmail(auth, email, { url: 'http://localhost:3000/myaccount/login' })
//   } catch (error: any) {
//     return { error: error.message }
//   }
// }

// export const deleteAccount = async () => {
//   try {
//     if (auth.currentUser) await deleteUser(auth.currentUser)
//   } catch (error: any) {
//     return { error: error.message }
//   }
// }

// export const updateUserPassword = async (newPassword: string) => {
//   try {
//     if (auth.currentUser) await updatePassword(auth.currentUser, newPassword)
//     return 'Successfully updated password.'
//   } catch (error: any) {
//     return { error: error.message }
//   }
// }
